/* em-cart.js - Shopify's cart, spoken to the way the prototype's bag was:
   EMCart.add([{id, quantity}]) resolves when the lines are in, and every
   [data-cart-count] in the header reads the new total. */
(function () {
  'use strict';

  /* Sept 28: the rung a design will actually be charged against, shared so the PAGE can show the
     same number the till takes. Until today the builders displayed the sum of the beads while the
     cart charged the nearest rung at or above it, which meant a sparse strand read $4.05 and rang
     up $28. One function, two callers, no way for them to drift apart again.
       null                  - no ladder (a single-variant product): the caller shows its own total
       {id, price, floor}    - the rung that will be charged, and the cheapest rung there is
       {over:true, ...}      - above every rung; the design cannot be ordered at all
     `floor` is what lets the page say "minimum" only when the design really is under the bottom
     rung, rather than on every ordinary rounding up to the next $2. */
  window.emTier = function (want) {
    var tiers = window.EM_BUILDER_TIERS;
    want = Number(want || 0);
    if (!tiers || tiers.length < 2 || !(want > 0)) return null;
    var byPrice = tiers.slice().sort(function (a, b) { return a.price - b.price; });
    var floor = byPrice[0].price;
    var fits = byPrice.filter(function (t) { return t.price >= want - 0.001; });
    if (fits.length) return { id: fits[0].id, price: fits[0].price, floor: floor };
    var top = byPrice[byPrice.length - 1];
    return { over: true, id: top.id, price: top.price, floor: floor };
  };

  /* Oct 7: once the ladder is retired the builder product becomes one fixed line beside the beads, and
     its price is part of what the cart charges. emTier returns null at one variant - correctly, there is no
     rung to pick - so a page that only asked emTier would show the beads and charge beads+line. That is the
     display/till divergence this file has been bitten by twice. Both builders add this to what they show. */
  window.emMakingCharge = function () {
    var tiers = window.EM_BUILDER_TIERS;
    if (!tiers || tiers.length !== 1) return 0;
    return Number(tiers[0].price) || 0;
  };

  var R = window.EM_ROUTES || { add: '/cart/add', cart: '/cart' };
  function count() {
    return fetch(R.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = 'Bag (' + c.item_count + ')'; });
        return c;
      });
  }
  function add(items) {
    return fetch(R.add + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add'); });
      return r.json();
    }).then(function (j) { return count().then(function () { return j; }); });
  }
  window.EMCart = { add: add, count: count };
})();

/* EMBag - the prototype's bag, spoken by every ported page: EMBag.add({id,...})
   where id is the catalogue id, which is the product's handle on the store
   (the generators and the two twins mapped). The line goes into Shopify's
   cart; nothing here holds a price. A builder's design (atelier-*, box-*) adds
   the product the page names in its settings, with the design as properties,
   and says so plainly when there is none yet. */
(function () {
  'use strict';
  var R = window.EM_ROUTES || { add: '/cart/add', cart: '/cart', root: '/' };
  var root = (R.root || '/').replace(/\/?$/, '/');
  var GEN = { 'gen-7.83': '7-83-hz-earth-frequency-generator', 'gen-174': '174hz-frequency-generator', 'gen-417': '417hz-frequency-generator',
              'gen-432': '432hz-frequency-generator', 'gen-528': '528hz-frequency-generator', 'gen-639': '639hz-frequency-generator', 'gen-963': '963hz-frequency-generator', 'gen-1111': '1111hz-frequency-generator' };
  var TWIN = { 'copper-plate': 'solid-copper-plate', 'frequency-bag': 'frequency-generator-bag' };
  function handleOf(id) { id = String(id || ''); var H = window.EM_HANDLE || {}; return H[id] || GEN[id] || TWIN[id] || id; }
  function href(id) { return root + 'products/' + encodeURIComponent(handleOf(id)); }
  var last = 0, subs = [];
  function toast(msg) {
    var t = document.getElementById('em-bag-toast');
    if (!t) {
      t = document.createElement('div'); t.id = 'em-bag-toast'; t.setAttribute('role', 'status');
      t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);background:#1D2739;color:#fff;font:500 13px/1.4 "Instrument Sans",system-ui,sans-serif;padding:11px 16px;border-radius:999px;z-index:9999;opacity:0;transition:opacity .25s;pointer-events:none;max-width:88vw;text-align:center';
      document.body.appendChild(t);
    }
    t.textContent = msg; t.style.opacity = '1';
    clearTimeout(t._t); t._t = setTimeout(function () { t.style.opacity = '0'; }, 2400);
  }
  function addByHandle(handle, qty, props) {
    return fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('Not in the store yet'); return r.json(); })
      .then(function (p) {
        var vs = p.variants || [], open = vs.filter(function (x) { return x.available; }), v = open[0];
        if (!v) throw new Error('Sold out');
        /* Sept 14 (QA, then the independent check): the site's one rule, as in snippets/em-choose.liquid. A piece with more
           than one variant in stock is chosen on its own page, whatever the option is called (a bundle's Type used to go
           in as the Starter). A quantity pack (the generators' "# of Generators") goes straight in at one. */
        var opt = p.options && p.options[0]; opt = String((opt && (opt.name || opt)) || '').toLowerCase();
        if (!props && open.length > 1 && !/#|number of|quantity/.test(opt)) {
          location.href = root + 'products/' + encodeURIComponent(handle) + '?choose=1';
          return false;
        }
        var line = { id: v.id, quantity: qty || 1 }; if (props) line.properties = props;
        return window.EMCart.add([line]);
      });
  }
  function refresh() { return window.EMCart.count().then(function (c) { last = c.item_count; subs.forEach(function (f) { f(last); }); return last; }); }
  function add(item) {
    item = item || {};
    var id = String(item.id || '');
    var p;
    if (/^(atelier|box)-/.test(id)) {
      var v = window.EM_BUILDER_VARIANT;
      if (!v) { toast('Ordering opens when the store carries this piece'); return Promise.resolve(false); }
      /* Sept 25: charge what the design costs. Shopify will not accept a price from the storefront, so the product
         carries a ladder of price variants and we pick the rung that covers this design - the cheapest variant at
         or above the total, so nobody is ever undercharged and nobody pays more than one rung's rounding. If the
         design somehow exceeds every rung we take the dearest and say so rather than quietly charging too little,
         because a bracelet sold under cost is worse than a bracelet not sold. A single-variant product keeps its
         old behaviour. */
      var rung = window.emTier(item.price);
      if (rung) {
        if (rung.over) {
          toast('This design is above the highest price we can charge — please get in touch');
          return Promise.resolve(false);
        }
        v = rung.id;
      }
      /* Sept 25 (Sara): "when the order comes through, there will be the labeled download of the bracelet for
         stringing purposes ... we will need to outsource the stringing so we want to make sure its super clear to
         whoever is making it." It was not clear at all: the order carried a name and location.href, and the builder
         only writes the design into the address bar when someone presses Copy share link - so an outsourced
         stringer would have received "Morning - 7.5in" and a link to an empty builder. The builder passes its own
         properties now: what to pick, what order to string them in, and a link that actually rebuilds the piece.
         Line item properties print on the packing slip, which is where the person making it will read them. */
      var props = { 'Design': item.name || '' };
      if (item.props) for (var pk in item.props) if (item.props[pk]) props[pk] = item.props[pk];
      if (!props['Link']) props['Link'] = location.href;

      /* Oct 7 (Sara): "is there a way that when someone purchases the bracelet, that the inventory of the
         beads can be taken out of inventory? This way it would account for the actual cost (for accounting
         reasons) and help us keep inventory."

         It cannot be done while the order carries one line. Shopify subtracts what the order SAYS was sold,
         and the order said "one Build Your Own Bracelet" - the beads were only text on it. So the beads go
         in as their own lines, at their own prices, and Shopify deducts them because they really were sold.
         No app, no service, nothing to maintain.

         The switch is the builder product itself, so neither of us has to time a deploy against the other.
         While it still carries its ladder of price rungs, this behaves exactly as it always has. The day the
         product is reduced to ONE variant, the ladder is gone and there is nothing to pick, so the beads are
         itemised and that single variant becomes the line that names the piece and carries the design. Set
         it to $0 and the customer pays exactly the beads; give it a price and that is the making charge. */
      var tiers = window.EM_BUILDER_TIERS || [];
      if (item.lines && item.lines.length && tiers.length <= 1) {
        var lines = item.lines.map(function (l) { return { id: l.id, quantity: l.quantity }; });
        /* the builder product last, so the packing slip reads beads-then-piece, and it holds the design */
        lines.push({ id: v, quantity: 1, properties: props });
        p = addWholeDesign(lines);
      } else {
        p = window.EMCart.add([{ id: v, quantity: 1, properties: props }]);
      }
    } else p = addByHandle(handleOf(id));
    return p.then(function (r) { if (r !== false) { toast('Added to bag'); refresh(); } return r; })
      .catch(function (e) { toast(e && e.message ? e.message : 'Could not add to bag'); return false; });
  }
  /* Oct 7: Shopify's /cart/add.js is NOT atomic across lines. Asked for three stones where one was
     short, it answered 422 "Only 26 items were added to your cart due to availability" - and KEPT the
     two that fit. A design is not a shopping list: a bracelet missing one bead is not a smaller
     bracelet, it is a wrong one, and it would have sat in the cart ready to check out behind an error
     message that said the add had failed. That is the fault we fixed on 5 Oct arriving through a worse
     door, because this time nothing on screen would have disagreed with it.

     So the whole design goes in or none of it does. The cart is read first, the add attempted, and on
     any failure every line we touched is put back to the quantity it had before. Shopify's own message
     never names what ran out, so the culprit is worked out by comparing what the cart holds against
     what was asked for, and named. */
  function addWholeDesign(lines) {
    var want = {};
    lines.forEach(function (l) { want[l.id] = (want[l.id] || 0) + l.quantity; });
    var prior = {};
    return fetch(R.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (before) {
        (before.items || []).forEach(function (i) { prior[i.variant_id] = i.quantity; });
        return window.EMCart.add(lines);
      })
      .catch(function (err) {
        /* Read the cart BEFORE putting it back. Shopify's partial add is the only evidence of which
           piece ran out - once the restore has run, every line we asked for is back to its old
           quantity and they all look short. Work out the culprit first, undo second. */
        return fetch(R.cart + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (midway) {
            var got = {};
            (midway.items || []).forEach(function (i) { got[i.variant_id] = i.quantity; });
            var shortNames = Object.keys(want).filter(function (id) {
              return (got[id] || 0) < (prior[id] || 0) + want[id];
            }).map(function (id) { return nameOfVariant(Number(id)); }).filter(Boolean);
            var updates = {};
            Object.keys(want).forEach(function (id) { updates[id] = prior[id] || 0; });
            return fetch(R.cart + '/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ updates: updates })
            }).then(function () {
              if (!shortNames.length) throw new Error('One of these stones just ran out — try again');
              var who = shortNames.slice(0, 2).join(' and ');
              var verb = shortNames.length > 1 ? 'them' : 'it';
              throw new Error(who + (shortNames.length > 1 ? ' have' : ' has') +
                              ' just run out — swap ' + verb + ' and try again');
            });
          })
          .catch(function (e) { throw (e instanceof Error ? e : err); });
      });
  }
  function nameOfVariant(id) {
    var lists = [window.EM_BEADS, window.EM_BOX_GEMS];
    for (var i = 0; i < lists.length; i++) {
      var L = lists[i] || [];
      for (var j = 0; j < L.length; j++) if (Number(L[j].vid) === id) return L[j].name;
    }
    return null;
  }

  window.EMBag = { add: add, open: function () { location.href = R.cart; }, count: function () { return last; },
                   on: function (f) { subs.push(f); }, href: href, handle: handleOf, addByHandle: addByHandle, toast: toast, refresh: refresh };
  /* the intention pages' generator cards: a button with the catalogue id and nothing else */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('button.radd[data-id]'); if (!b || b.hasAttribute('data-hz')) return;
    if (b.closest('#feat, #rooms')) return;
    add({ id: b.getAttribute('data-id') });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { refresh(); }); else refresh();
  /* their Rebuy cart changes the cart itself (the product form, its drawer): the header count follows */
  document.addEventListener('rebuy:cart.change', function () { refresh(); });
})();
